import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export function useCustomFields(module, recordId) {
  const [customData, setCustomData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!module || !recordId) return;
    setLoading(true);
    axios
      .get(`/api/custom-field-values?module=${module}&record_id=${recordId}`)
      .then(res => setCustomData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [module, recordId]);

  const saveCustomFields = useCallback(async (savedRecordId) => {
    if (!savedRecordId || Object.keys(customData).length === 0) return;
    await axios.post('/api/custom-field-values', {
      module,
      record_id: savedRecordId,
      custom_data: customData,
    });
  }, [module, customData]);

  return { customData, setCustomData, saveCustomFields, loading };
}